import { ApiRequest } from 'framework/api';

export function updatedPayloadToLoadAllData<T>(apiRequest: ApiRequest<T>) {
	apiRequest.payload.filter = {};
	apiRequest.payload.sort = [];
	apiRequest.payload.skip = 0;
	apiRequest.payload.take = 999;
}
